import Vue from 'vue';
import Router from 'vue-router';
import store from '../store'
//路由导航冗余报错（路由重复）
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router);
const BASE_URL = (process.env.NODE_ENV === "production"||process.env.NODE_ENV === "test") ? "/retireSchool/" : "/";

let baseRoute = [
    {
        path: '/',
        name: 'index',
        component: (resolve) => require(['../index.vue'], resolve),
        children: [
            {
                path: '/',
                name: 'home',
                meta: {
                    title: '首页'
                },
                component: (resolve) => require(['../views/home/home.vue'], resolve)
            },
            {
                path: '/allCourses',
                name: 'allCourses',
                meta: {
                    title: '全部课程'
                },
                component: (resolve) => require(['../views/allCourse/CourseList.vue'], resolve)
            },
            {
                path: '/detail',
                name: 'detail',
                meta: {
                    title: '课程详情'
                },
                component: (resolve) => require(['../views/common/detail.vue'], resolve)
            },
			
           
            {
                path: '/notice',
                name: 'notice',
                meta: {
                    title: '消息中心',
                    isLogin: true
                },
                component: (resolve) => require(['../views/notice/notice.vue'], resolve)
            },
			{
			    path: '/userInfoConfirm',
			    name: 'userInfo',
			    meta: {
			        title: '基本信息'
			    },
			    component: (resolve) => require(['../views/login/userInfo.vue'], resolve)
			},
            {
                path: '/myAccount',
                name: 'myAccount',
                meta: {
                    title: '个人中心',
                    isLogin: true
                },
                component: (resolve) => require(['../views/myAccount/myAccount.vue'], resolve),
                children: [
                    {
                        path: '/userInfo',
                        name: 'account',
                        meta: {
                            title: '个人基本信息',
                            isLogin: true
                        },
                        component: (resolve) => require(['../views/myAccount/userInfo.vue'], resolve)
                    },
                   {
                       path: '/myLeasson',
                       name: 'myLeasson',
                       meta: {
                           title: '我的课程',
                           isLogin: true
                       },
                       component: (resolve) => require(['../views/myCourse/myLeasson.vue'], resolve)
                   },
                    {
                        path: '/myInvoice',
                        name: 'myInvoice',
                        meta: {
                            title: '发票信息',
                            isLogin: true
                        },
                        component: (resolve) => require(['../views/myAccount/myInvoice.vue'], resolve)
                    },
                    {
                        path: '/dropCourse',
                        name: 'dropCourse',
                        meta: {
                            title: '退课申请',
                            isLogin: true
                        },
                        component: (resolve) => require(['../views/myCourse/dropCourse.vue'], resolve)
                    },
                    {
                        path: '/resetPassword',
                        name: 'resetPassword',
                        meta: {
                            title: '密码重置',
                            isLogin: true
                        },
                        component: (resolve) => require(['../views/myAccount/safety.vue'], resolve)
                    },
                    



                    {
                        path: '/myAccount/:currName',
                        name: 'setting',
                        meta: {
                            title: '帐户设置',
                            isLogin: true
                        },
                        component: (resolve) => require(['../views/myAccount/safety.vue'], resolve)
                    },
                ]
            },
            {
                path: '/404',
                name: '404',
                meta: {
                    title: '404'
                },
                component: (resolve) => require(['../views/common/404.vue'], resolve)
            },
        ]
    },

    {
        path: '/login',
        name: 'login',
        meta: {
            title: '登录'
        },
        component: (resolve) => require(['../views/login/login.vue'], resolve)
    },
    {
        path: '/login/token',
        name: 'loginToken',
        meta: {
            title: 'Token登录'
        },
        component: (resolve) => require(['../views/login/loginAsToken.vue'], resolve)
    },

    {
        path: '/login/wechat',
        name: 'loginWeChat',
        meta: {
            title: '微信登录'
        },
        component: (resolve) => require(['../views/login/loginAsWeChat.vue'], resolve)
    },

    {
        path: '*',
        redirect: '/home'
    }
];

let router = new Router({
    mode: 'history',
    base: BASE_URL,
    routes: baseRoute
});

router.beforeEach((to, from, next) => {
    let tokenS = sessionStorage.getItem('token_retire_school');
    let studentId = sessionStorage.getItem('studentId');
    store.commit("ADD_STUDENTID", studentId);
    store.commit("ADD_TOKEN", tokenS);
    if (to.name == 'nucleic_test'){

    }else if (to.name != 'myAccount') {
		if (to.meta.isLogin) {
			
		    if (tokenS) {
		        next();
		    }
		    else {
		        next({
		            path: '/login',
		            query: { redirect: to.fullPath }  // 将跳转的路由path作为参数，登录成功后跳转到该路由
		        })
		    }
		}
		else {
		    next();
		}
	} 
    
})

export default router;
